import React from 'react';
import PropTypes from 'prop-types';
import colors from '../../../customizations/js/color-variables';

export const IconUser = ({ className, color }) => (
  <svg className={className} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#121D41" />
    <path
      d="M10.8926 29.6426C10.8926 25.8926 15.4675 21.989 19.9997 21.989M19.9997 21.989C24.5323 21.989 29.1069 25.3569 29.1069 29.6426M19.9997 21.989C23.2016 21.989 25.8066 19.3795 25.8066 16.1727C25.8066 12.9659 23.2016 10.3569 19.9997 10.3569C16.7978 10.3569 14.1928 12.9656 14.1928 16.1727C14.1928 19.3795 16.7978 21.989 19.9997 21.989Z"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

IconUser.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

IconUser.defaultProps = {
  className: '',
  color: colors.white,
};
